<template>
    <section id="after-movies">
        <div class="secondary-heading text-center">ESSENS TURKEY 2026</div>
        <h1 class="text-center mb-5"> {{ $t('webVidea') }} </h1>
        <div id="after-movies-container" class="container px-5 position-relative">
            <div class="row">
                <div class="col-xs-12-mine col-lg-4 col-xl-4 pt-3">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/1XLdsN0E8Ag?si=O0ts7XAgKQ_RVl03" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    </div> 
                </div>
                <div class="col-xs-12-mine col-lg-4 col-xl-4 pt-3">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/HNo3J_LYSBo" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-xs-12-mine col-lg-4 col-xl-4 pt-3">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/jiW8ML4qXvE?si=M8aXwQyuhftD1CBP" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    </div> 
                </div>
            </div>
        </div>
    </section>
</template>

<style>
    #after-movies {
        background-color: var(--grey-bg);
    }
</style>